module.exports = __webpack_public_path__ + "static/img/declaration-others-card.fe559ae0.svg";